const searchProvider = {
	dataBody: {
		name: {
			path: 'name',
		},
	},
};

export default searchProvider;
